import "./components/videos/watch.css";
import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App.tsx";
import { GoldenSparkles } from "./components/GoldenSparkles";
import { reloadOnceForAssetFailure } from "./lib/recoverLazyChunk";
import "./index.css";

window.addEventListener('vite:preloadError', event => {
  if (reloadOnceForAssetFailure()) event.preventDefault();
});

const root = document.getElementById('root')!;
const app = <><App /><GoldenSparkles /></>;
let hydrate = false;
try {
  hydrate = root.dataset.prerenderedHome === 'true' && window.location.pathname === '/' && !window.location.search && !window.location.hash && !localStorage.getItem('authToken');
} catch { /* Preserve ordinary rendering when storage is unavailable. */ }
if (hydrate) {
  // Let the already-rendered first screen paint before hydration can occupy
  // the main thread. This also avoids rare slow first paints on busy devices.
  requestAnimationFrame(() => requestAnimationFrame(() => {
    hydrateRoot(root, app, { onRecoverableError: (error, info) => console.error('Homepage hydration recovery', error, info.componentStack) });
  }));
}
else createRoot(root).render(app);
